export default __webpack_public_path__ + "assets/images/6.04543a.webp";